import styled from "styled-components";

export const  WrapperLabelText = styled.span`
    color: rgb(56,56,61);
    font-size: 14px;
    font-weight: 500;
`

export const WrapperTextValue = styled.span`
    color: rgb(56,56,61);
    font-size: 12px;
    font-weight:400;
`

export const WrapperTextContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

`